const CACHE_TIME = 1000 * 60 * 20; // 20 mins
const STALE_TIME = 1000 * 60 * 20; // 20 mins

export const DEFAULT_QUERY_PROPS = {
  staleTime: STALE_TIME,
  gcTime: CACHE_TIME,
  retry: false,
  refetchOnWindowFocus: false,
};
